import request from "./axios";
export function Find_password(data) {
  return request({ method: "post", url: "/Login/GetCode", data });
}
export function phoneCheck(data) {
  return request({ method: "post", url: "/Login/Getlist", data });
}
export function passwordCheck(data) {
  return request({ method: "post", url: "/Login/FindPassword", data });
}
